import { Component, OnInit } from '@angular/core';
import { NavController, ModalController, NavParams } from 'ionic-angular';
import { DailyWageSetService } from './../../services/dailywageset.service';
import { LoaddingService } from './../../providers/loadding.service';
import { StorageService } from './../../providers/storage.service';
import { AlertService } from './../../providers/alert.service';
import { PageDefault } from './../../pages/PageDefault';
import { UserModel } from './../../models/user.model';
import { AppConfig } from './../../app/app.config';
import { AddDailyWagesPage } from './adddailywages';
import { DailyWagesModel, DailyWagesRulesModel } from './../../models/dailywageset.model';
import * as $ from 'jquery';
/**
 * Generated class for the DailywagesetPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@Component({
    selector: 'page-setdailwages',
    templateUrl: 'setdailywages.html',
    providers: [
        DailyWageSetService,
    ]
})
export class SetDailyWagesPage {
    constructor(
        private dailywageset: DailyWageSetService,
        private loadding: LoaddingService,
        private storage: StorageService,
        private modalCtrl: ModalController,
        private navpar: NavParams,
        private config: AppConfig,
        public navCtrl: NavController,
        private alert: AlertService
    ) { }

    records;
    pagesize: number = PageDefault.PageSize();
    hasmore: boolean = false;
    flag: boolean = false;
    isHave: boolean = false;
    username: string;
    ionViewDidLoad() {
        this.username = this.navpar.get('userName');
        this.getDailyWageRules();
    }
    //添加日工资比例
    add(userName) {
        let modal = this.modalCtrl.create(AddDailyWagesPage, { userName: userName });
        modal.present();
        modal.onWillDismiss((data) => {
            if (data && data.isOk) {
                this.getDailyWageRules();
            }
        });
    }

    //获取当前用户日工资
    getDailyWageRules() {
        return this.dailywageset.getDailyWageRules(this.username).then(s => {
            if (s != null && s.length>0) {
                this.records = [];
                this.records = s;
                this.isHave = true;
            } else {
                this.isHave = false;
            }
        })
    }
}




// WEBPACK FOOTER //
// ./src/pages/dailywageset/setdailywages.ts